import { render, staticRenderFns } from "./ContestReadOnlyDocumentsView.vue?vue&type=template&id=f50dacb2&scoped=true&"
import script from "./ContestReadOnlyDocumentsView.vue?vue&type=script&lang=js&"
export * from "./ContestReadOnlyDocumentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f50dacb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
installComponents(component, {VCard})
